import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/payments-received")({
  beforeLoad: ({ context }) => guardRoute(context.me, "payments-received"),
  component: Outlet,
});
